import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { AppService, GRSSResponse } from 'src/app/_services/app.service';
import { ManageAccountsComponent } from '../manage-accounts.component';

@Component({
    selector: 'app-add-account',
    templateUrl: './add-account.component.html',
    standalone: false
})
export class AddAccountComponent implements OnInit {

  account: Account;

  // tslint:disable-next-line: max-line-length
  constructor(private translate: TranslateService, private service: AppService, @Inject('BASE_URL') private baseUrl: string, private http: HttpClient, public dialogRef: MatDialogRef<ManageAccountsComponent>) { }

  ngOnInit() {
    this.InitializeForm();
  }

  /** Cancel button event */
  OnCancel() {
    this.dialogRef.close(0);
  }

  /** Save button event */
  OnSaveAccount() {
    if (this.account.code && this.account.organisation) {
      this.service.showSpinner();
      this.http.post<GRSSResponse>(this.baseUrl + 'api/account/addAccount/', this.account).subscribe(result => {
        let navigated = false;
        if (result.statusCode === 1) {
          this.service.SaveStatus(false, 'Accounts.addAccount.header', result.statusMessage);
          this.dialogRef.close(1);
        } else if (result.statusCode === 4) {
          navigated = true;
          this.dialogRef.close(1);
          this.service.SaveStatus(true, 'Accounts.addAccount.header', result.statusMessage);
        } else {
          this.service.SaveStatus(false, this.translate.instant('Accounts.addAccount.header'), result.statusMessage, true);
        }

        if (!navigated) {
        }
      }).add(() => {
        this.service.hideSpinner();
      });
    }
  }

  /** Initializes the form values */
  InitializeForm() {
    this.account = {
      accountId: '',
      code: '',
      enabled: false,
      organisation: ''
    };
  }

}

/** An inteface to access account details */
interface Account {
  accountId: string;
  code: string;
  organisation: string;
  enabled: boolean;
}
